module.exports = __webpack_public_path__ + "static/media/arlington.7be99a74.jpg";